import { useMemo } from 'react';
import { passageMeasureIds } from '@/music/passage';
import { useStore } from '@/state/store';

export function usePassageSelection() {
  const passage = useStore((s) => s.passage);
  const form = useStore((s) => s.score.form);
  const selectPassage = useStore((s) => s.selectPassage);
  const extendPassage = useStore((s) => s.extendPassage);
  const clearPassage = useStore((s) => s.clearPassage);
  const formIds = useMemo(() => form.map((measure) => measure.id), [form]);
  const passageIdSet = useMemo(
    () => new Set(passage ? passageMeasureIds(formIds, passage) : []),
    [formIds, passage],
  );
  const onSelectPassage = (fromId: string, toId: string, opts?: { extend?: boolean }) => {
    if (opts?.extend) extendPassage(toId);
    else selectPassage(fromId, toId);
  };
  return {
    passage,
    formIds,
    passageIdSet,
    onSelectPassage,
    onClearPassage: clearPassage,
  };
}
